import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=4f86d70d&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"
import style0 from "./Slides.vue?vue&type=style&index=0&id=4f86d70d&prod&scoped=true&lang=css"
import style1 from "./Slides.vue?vue&type=style&index=1&id=4f86d70d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f86d70d",
  null
  
)

export default component.exports